import React, { useState, forwardRef } from "react";
import "../../pages/customerMaster/customerMaster.scss";
import { default as ReactSelect } from "react-select";
import { components } from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import CreditLimitApproval from "./CreditLimitApproval";
import DistributorPayment from "./DistributorPayment";
import Modal from 'react-bootstrap/Modal';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// datepicker start
const ExampleCustomInput = forwardRef(
  ({ value, onClick, onChange, doc, index }, ref) => (
    <input
      value={value}
      className="example-custom-input form-control"
      onClick={onClick}
      onChange={onChange}
      ref={ref}
      placeholder="DD/MM/YYYY"
      disabled={doc?.fileName == ""}
    ></input>
  )
);
// datepicker end
const CompanyDocuments = ({
  DocumentsName,
  HandleFileChange,
  values,
  handleDocumentChange,
  errors,
  removeAttachedFile,
  handleDeleteFile,
  handleAttachmentDate,
  docError,
  setValues
}) => {
  // mui progress bar start
  const [progress, setProgress] = React.useState(0);
  const [buffer, setBuffer] = React.useState(10);

  const progressRef = React.useRef(() => { });
  React.useEffect(() => {
    progressRef.current = () => {
      if (progress > 100) {
        setProgress(0);
        setBuffer(10);
      } else {
        const diff = Math.random() * 10;
        const diff2 = Math.random() * 10;
        setProgress(progress + diff);
        setBuffer(progress + diff + diff2);
      }
    };
  });

  React.useEffect(() => {
    const timer = setInterval(() => {
      progressRef.current();
    }, 500);

    return () => {
      clearInterval(timer);
    };
  }, []);
  // mui progress bar end
  const [startDate, setStartDate] = useState(new Date());

  const [distributertag, setDistributerTag] = useState([]);
  const [showCreditLimit, setShowCreditLimit] = useState(false);
  const [show, setShow] = useState(false);

  const [companyImageShow, setCompanyImageShow] = useState({show:false,imagePath:""});
  
    const handleClose = () => setCompanyImageShow({show:false,imagePath:""});
    const handleShow = (imageurl) => setCompanyImageShow({show:true,imagePath:imageurl});

  const handleChange = (selected) => {
    setDistributerTag(selected);
  };
  
  const handleShowCreditLimit = () => {
    setShowCreditLimit((prevValue) => !prevValue);
  };

  return (
    <>
      <div className="card company-branding-card mb-2">
        <div className="card-header">
          <h2>Company Branding Assets</h2>
        </div>
        <div className="card-body">
          <div className="row company-document-upload-row">
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div>
                <form id="file-upload-form" className="uploader">
                  <input
                    id="file-upload-datasheet-company"
                    type="file"
                    name="logoUrl"
                    accept=".jpg,.png"
                    onChange={HandleFileChange}
                    onClick={(e) => {
                      e.target.value = null;
                    }}
                  />
                  {values?.logo?.url ? (
                    <div class="after-upload-img">
                      <img src={values?.logo?.url}/>
                      <div class="edit-actions">
                        <div class="d-flex gap-2">
                          {/* <i class="fas fa-pencil-alt"></i> */}
                          <i class="far fa-eye" onClick={()=>{handleShow(values?.logo?.url)}}></i>
                          <i class="far fa-trash-alt" onClick={(e) => handleDeleteFile(e, "logo")}></i>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <label for="file-upload-datasheet-company">
                      <div id="start">
                        <span class="material-symbols-outlined upload-icon">
                          cloud_upload
                        </span>
                        <div className="attach-label">
                          <h6>Upload Company Logo</h6>
                          <p>
                            Only JPG, JPEG, and PNG files with a maximum file
                            size of 1MB
                          </p>
                        </div>
                      </div>
                    </label>
                  )}
                  {errors?.logoUrl ? (
                    <p className="form-error ">{errors?.logoUrl}</p>
                  ) : errors?.logoFileSize ? (
                    <p className="form-error ">{errors?.logoFileSize}</p>
                  ) : (
                    ""
                  )}
                </form>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div>
                <form id="file-upload-form" className="uploader">
                  <input
                    id="file-upload-datasheet-header"
                    type="file"
                    name="headerUrl"
                    accept=".jpg,.png"
                    onChange={HandleFileChange}
                    onClick={(e) => {
                      e.target.value = null;
                    }}
                  />
                  {values?.header?.url ? (
                    <div class="after-upload-img">
                      <img src={values?.header?.url}/>
                      <div class="edit-actions">
                        <div class="d-flex gap-2">
                          {/* <i class="fas fa-pencil-alt"></i> */}
                          <i class="far fa-eye" onClick={()=>{handleShow(values?.header?.url)}}></i>
                          <i class="far fa-trash-alt" onClick={(e) => handleDeleteFile(e, "header")}></i>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <label for="file-upload-datasheet-header">
                      <div id="start">
                        <span class="material-symbols-outlined upload-icon">
                          cloud_upload
                        </span>
                        <div className="attach-label">
                          <h6>Upload Letterpad Header</h6>
                          <p>
                            Only JPG, JPEG, and PNG files with a maximum
                            file size of 1MB
                          </p>
                        </div>
                      </div>
                    </label>
                  )}
                  {errors?.headerUrl ? (
                    <p className="form-error ">{errors?.headerUrl}</p>
                  ) : errors?.headerFileSize ? (
                    <p className="form-error ">{errors?.headerFileSize}</p>
                  ) : (
                    ""
                  )}
                </form>
              </div>
            </div>
            <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
              <div>
                <form id="file-upload-form" className="uploader">
                  <input
                    id="file-upload-datasheet-footer"
                    type="file"
                    name="footerUrl"
                    accept=".jpg,.png"
                    onChange={HandleFileChange}
                    onClick={(e) => {
                      e.target.value = null;
                    }}
                  />
                  {values?.footer?.url ? (
                    <div class="after-upload-img">
                      <img src={values?.footer?.url}/>
                      <div class="edit-actions">
                        <div class="d-flex gap-2">
                          {/* <i class="fas fa-pencil-alt"></i> */}
                          <i class="far fa-eye" onClick={()=>{handleShow(values?.footer?.url)}}></i>
                          <i class="far fa-trash-alt"  onClick={(e) => handleDeleteFile(e, "footer")}></i>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <label for="file-upload-datasheet-footer">
                      <div id="start">
                        <span class="material-symbols-outlined upload-icon">
                          cloud_upload
                        </span>

                        <div className="attach-label">
                          <h6>Upload Letterpad Footer</h6>
                          <p>
                            Only JPG, JPEG, and PNG files with a maximum
                            file size of 1MB
                          </p>
                        </div>
                      </div>
                    </label>
                  )}
                  {errors?.footerUrl ? (
                    <p className="form-error ">{errors?.footerUrl}</p>
                  ) : errors?.footerFileSize ? (
                    <p className="form-error ">{errors?.footerFileSize}</p>
                  ) : (
                    ""
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card documents-card mb-2">
        <div class="card-header">
          <h2>{DocumentsName}</h2>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-2">
              <div className="customer-documents-table-sec">
                <table className="table table-striped table-borderless">
                  <thead>
                    <tr>
                      <th scope="col" className="sort-icon">
                        File Name
                      </th>
                      <th scope="col">Attached File</th>
                      <th scope="col">Expiry On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {values?.docs?.length > 0 ? (
                      values?.docs?.map((doc, ind) => (
                        <tr key={doc?.id}>
                          <td className="text-align" style={{ width: "25%" }}>
                            {doc?.documentName}
                          </td>
                          <td>
                            <div id="file-upload-form" className="upload-btn">
                              <input
                                id={`file-upload-attachment-document-${doc?.id}`}
                                type="file"
                                name="commercialRegistration"
                                accept=".pdf"
                                onChange={(e) =>
                                  handleDocumentChange(e, doc?.id)
                                }
                                onClick={(e) => {
                                  e.target.value = null;
                                }}
                              />
                              {doc?.fileName == "" ? (
                                <label
                                  for={`file-upload-attachment-document-${doc?.id}`}
                                  id="file-drag"
                                >
                                  <p>Attach File</p>
                                  <span class="material-icons-outlined">
                                    file_upload
                                  </span>
                                </label>
                              ) : (
                                <label>
                                  <p>{doc?.fileName}</p>
                                  <i
                                    className="fas fa-times"
                                    onClick={(e) =>
                                      removeAttachedFile(doc?.id, ind)
                                    }
                                  ></i>
                                </label>
                              )}
                              {show && (
                                <div className="upload-popup">
                                  <div className="upload-container">
                                    <div className="d-flex mb-2">
                                      <p className="mr-2">Filename</p>
                                      <Box sx={{ my: "auto", width: "100%" }}>
                                        <LinearProgress
                                          variant="buffer"
                                          value={progress}
                                          valueBuffer={buffer}
                                        />
                                      </Box>
                                      <i className="fas fa-times ml-2"></i>
                                    </div>
                                    <div className="d-flex justify-content-end mt-3">
                                      <button
                                        type="button"
                                        className="btn btn-link clear-btn"
                                        onClick={(e) => setShow(!show)}
                                      >
                                        Clear
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-link upload-btn"
                                        onClick={(e) => setShow(!show)}
                                      >
                                        Upload
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>

                            <div className="d-none">
                              <div className="uploaded-file-name">
                                {doc?.fileName == "" ? (
                                  <label>
                                    <div className="upload-caption">
                                      Attach File
                                    </div>
                                  </label>
                                ) : (
                                  <label>
                                    <p>{doc?.fileName}</p>
                                  </label>
                                )}
                              </div>
                              <form
                                id="file-upload-form"
                                className="upload-btn"
                              >
                                <input
                                  id={`file-upload-attachment-document-${doc?.id}`}
                                  type="file"
                                  name="commercialRegistration"
                                  accept=".pdf"
                                  onChange={(e) =>
                                    handleDocumentChange(e, doc?.id)
                                  }
                                  onClick={(e) => {
                                    e.target.value = null;
                                  }}
                                />
                                <label
                                  for={`file-upload-attachment-document-${doc?.id}`}
                                  id="file-drag"
                                >
                                  <span class="material-icons-outlined">
                                    file_upload
                                  </span>
                                </label>
                              </form>
                              {doc?.fileName != "" && (
                                <button
                                  className="btn delete-icon-btn"
                                  type="button"
                                >
                                  <i
                                    className="far fa-trash-alt"
                                    onClick={(e) =>
                                      removeAttachedFile(doc?.id, ind)
                                    }
                                  ></i>
                                </button>
                              )}
                              {show && (
                                <div className="upload-popup">
                                  <div className="upload-container">
                                    <div className="d-flex mb-2">
                                      <p className="mr-2">Filename</p>
                                      <Box sx={{ my: "auto", width: "100%" }}>
                                        <LinearProgress
                                          variant="buffer"
                                          value={progress}
                                          valueBuffer={buffer}
                                        />
                                      </Box>
                                      <i className="fas fa-times ml-2"></i>
                                    </div>
                                    <div className="d-flex justify-content-end mt-3">
                                      <button
                                        type="button"
                                        className="btn btn-link clear-btn"
                                        onClick={(e) => setShow(!show)}
                                      >
                                        Clear
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-link upload-btn"
                                        onClick={(e) => setShow(!show)}
                                      >
                                        Upload
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </td>
                          <td style={{ width: "25%" }}>
                            <div className="d-flex justify-content-end">
                              <DatePicker
                                name={doc?.id}
                                selected={doc?.file?.expDate}
                                onChange={(date) =>
                                  handleAttachmentDate(date, doc?.id)
                                }
                                customInput={
                                  <ExampleCustomInput doc={doc} index={ind} />
                                }
                                dayClassName={() =>
                                  "example-datepicker-day-class"
                                }
                                popperClassName="example-datepicker-class"
                                dateFormat="dd/MM/yyyy"
                                minDate={new Date()}
                              />
                              {doc?.fileName != "" &&
                                doc?.file?.expDate != null && (
                                  <span class="popover__wrapper ml-1">
                                    <i class="fas fa-info-circle"></i>
                                    <div class="popover__content">
                                      <p>
                                        This file has been expiring soon, please
                                        update the file
                                      </p>
                                    </div>
                                  </span>
                                )}
                            </div>
                            {docError[ind] && (
                              <p className="form-error">{docError[ind]}</p>
                            )}
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>No Files</tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <DistributorPayment setValues={setValues} values={values} errors={errors} />
      <CreditLimitApproval />

      {/* imgViewModal start */}
      <Modal show={companyImageShow?.show} onHide={handleClose} animation={false} size="md" className="imgViewModal"
        aria-labelledby="contained-modal-title-vcenter"
        centered>
        <Modal.Body>
          <Row>
            <Col lg={12}>
              <div className="text-right pt-3 pb-3">
                <i className="fas fa-times" onClick={handleClose}></i>
              </div>
            </Col>
            <Col lg={12}>
              <div className="text-center">
                <img src={companyImageShow?.imagePath} alt="Product Image"></img>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
      {/* imgViewModal end */}
    </>
  );
};

export default CompanyDocuments;
